import stickers from 'public/stickers.json';

export default function (type: CustomizerStickerT): StickerConfigI {
  return (stickers as unknown as Record<CustomizerStickerT, StickerConfigI>)[type];
}
